/** Projects with shown !== false are public. Missing field defaults to visible. */
export const isProjectShown = (project) => project?.shown !== false;

export const filterShownProjects = (projects = []) =>
  projects.filter(isProjectShown);
